import { useEffect, useState } from 'react';

/**
 * true enquanto a pessoa rola a página para BAIXO, só em telas estreitas.
 *
 * No celular o header some ao descer (mais conteúdo por tela) e volta assim que
 * a pessoa sobe um pouco, que é quando ela procura busca ou menu. Acima de
 * `larguraMax`, ou antes de `limiar` px de rolagem, nunca oculta.
 *
 * Um único ouvinte de scroll passivo, agrupado por requestAnimationFrame, e
 * uma folga de 8 px para ignorar tremidas do dedo.
 */
export default function useOcultarAoRolar({ larguraMax = 767, limiar = 160, pausado = false } = {}) {
    const [oculto, setOculto] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;
        const mq = window.matchMedia ? window.matchMedia(`(max-width: ${larguraMax}px)`) : null;
        let ultimo = window.scrollY;
        let agendado = false;

        const avaliar = () => {
            agendado = false;
            const y = window.scrollY;
            if (pausado || (mq && !mq.matches) || y < limiar) {
                setOculto(false);
                ultimo = y;
                return;
            }
            const delta = y - ultimo;
            if (Math.abs(delta) < 8) return;
            setOculto(delta > 0);
            ultimo = y;
        };
        const aoRolar = () => {
            if (agendado) return;
            agendado = true;
            window.requestAnimationFrame(avaliar);
        };

        window.addEventListener('scroll', aoRolar, { passive: true });
        return () => window.removeEventListener('scroll', aoRolar);
    }, [larguraMax, limiar, pausado]);

    return pausado ? false : oculto;
}
